import HUBS from "@/data/hubs.yml";

function sameOrigin(a, b) {
  const urlA = new URL(a);
  const urlB = new URL(b);
  return urlA.origin === urlB.origin;
}

export default {
  data() {
    const currentTime = new Date().getTime();

    const expiredEvents = [];
    const upcomingEvents = [];

    for (let event of HUBS) {
      const expired = event.nextEvent.date
        ? new Date(
            event.nextEvent.date.year,
            event.nextEvent.date.month - 1,
            event.nextEvent.date.day + 3
          ).getTime() < currentTime
        : false;

      if (expired) {
        expiredEvents.push(event);
      } else {
        upcomingEvents.push(event);
      }
    }

    expiredEvents.reverse();

    return {
      expiredEvents,
      upcomingEvents,
    };
  },
  methods: {
    onHubClick(event, href) {
      console.log(event, href);
      if (sameOrigin(href, window.location)) {
        event.preventDefault();
        this.$emit("close");
      }
    },
  },
};
